// src/utils/api.js
import { SUBSCRIPTION_ENDPOINTS, AUTH_ENDPOINTS, USER_ENDPOINTS, API_BASE_URL } from "./constants";

export const fetchSubscriptionPlans = async () => {
  try {
    const response = await fetch(SUBSCRIPTION_ENDPOINTS.GET_ALL_PLANS);
    if (!response.ok) {
      throw new Error("Failed to fetch subscription plans");
    }
    const data = await response.json();
    if (data.success && Array.isArray(data.plans)) {
      return data.plans;
    } else {
      throw new Error("Invalid data structure received from API");
    }
  } catch (error) {
    console.error("Error fetching subscription plans:", error);
    throw error;
  }
};

export const registerUser = async (formData, encryptedPassword) => {
  const url = AUTH_ENDPOINTS.REGISTER;
  const data = {
    fullname: `${formData.firstName} ${formData.lastName}`,
    email: formData.email,
    password: formData.password,
    userType: formData.userType,
    encryptPhrase: encryptedPassword,
    planId: formData.planId,
    activationCode: formData.activationCode ? formData.activationCode.trim() : undefined
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!result.success) {
    throw new Error(result.message || 'Failed to create account');
  }

  return result;
};
export const validateActivationCode = async (code) => {
  const response = await fetch(AUTH_ENDPOINTS.VALIDATE_ACTIVATION_CODE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  });

  const result = await response.json();

  if (!response.ok || !result.valid) {
    throw new Error(result.message || 'Invalid activation code');
  }

  return result;
};

export const initializeGiftPayment = async (data) => {
  const response = await fetch(`${API_BASE_URL}/gift/initialize`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const verifyGiftPayment = async (data) => {
  const response = await fetch(`${API_BASE_URL}/gift/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const createGiftPaypalOrder = async (data) => {
  const response = await fetch(`${API_BASE_URL}/gift/create-paypal-order`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const captureGiftPaypalOrder = async (data) => {
  const response = await fetch(`${API_BASE_URL}/gift/capture-paypal-order`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return response.json();
};
